import PropTypes from 'prop-types';
import Form, {
  FormGroup,
  FormControl,
  TextFieldControl,
  EmailFieldControl,
  TextAreaControl,
  CountryFieldControl,
  FormActions,
  FormSubmit,
  submitForm,
} from '@/components/Forms';
import { notifySuccess, notifyError } from '@/components/Toaster';
import salesFormValidationSchema from './salesFormValidationSchema';

const defaultProps = {
  onSuccess: () => notifySuccess(`
    Tu mensaje se ha enviado. Uno de nuestros agentes se
    estará poniendo en contacto lo más pronto posible.
  `),
  onError: () => notifyError(`
    Ha ocurrido un error cuando intentamos enviar tu mensaje.
    Por favor inténtalo nuevamente.
  `),
};

const propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  children: PropTypes.func.isRequired,
};

export default function SalesForm({
  onSuccess,
  onError,
}) {
  return (
    <Form
      initialValues={{
        firstname: '',
        lastname: '',
        company: '',
        email: '',
        country: '',
        message: '',
        website: '',
      }}
      validationSchema={salesFormValidationSchema}
      onSubmit={(values, {
        setSubmitting,
        resetForm,
      }) => {
        submitForm('7663692/39eaade9-5eb1-4278-a4e8-cca475a3ffdd', values, {
          setSubmitting,
          onSuccess: function() {
            resetForm();
            onSuccess();
          },
          onError: function(errors) {
            onError();
          },
        });
      }}
    >
      {({
        handleChange,
        handleBlur,
        isSubmitting,
        setFieldValue,
        validateForm,
        errors,
        touched,
        values,
        isValid,
      }) => {
        const countryHasError = touched.country && errors.country !== undefined;
      
        return (
          <div className="flex flex-col space-y-4 lg:space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:gap-6">
              <div className="md:col-span-1 space-y-4 lg:space-y-6">
                <FormGroup>
                  <FormControl
                    htmlFor="firstname"
                    label="Nombres"
                    error={errors.firstname}
                    touched={touched.firstname}
                  >
                    <TextFieldControl
                      id="firstname"
                      name="firstname"
                      placeholder="Juan"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.firstname}
                      disabled={isSubmitting}
                      error={errors.firstname}
                      touched={touched.firstname}
                      required
                    />
                  </FormControl>
                </FormGroup>
              </div>
              <div className="md:col-span-1 space-y-4 lg:space-y-6">
                <FormGroup>
                  <FormControl
                    htmlFor="lastname"
                    label="Apellidos"
                    error={errors.lastname}
                    touched={touched.lastname}
                  >
                    <TextFieldControl
                      id="lastname"
                      name="lastname"
                      placeholder="Díaz"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastname}
                      disabled={isSubmitting}
                      error={errors.lastname}
                      touched={touched.lastname}
                      required
                    />
                  </FormControl>
                </FormGroup>
              </div>
            </div>
            <FormGroup>
              <FormControl
                htmlFor="company"
                label="Empresa"
                error={errors.company}
                touched={touched.company}
              >
                <TextFieldControl
                  id="company"
                  name="company"
                  placeholder="Agile Company"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.company}
                  disabled={isSubmitting}
                  error={errors.company}
                  touched={touched.company}
                  required
                />
              </FormControl>
            </FormGroup>
            <FormGroup>
              <FormControl
                htmlFor="email"
                label="Correo electrónico de trabajo"
                error={errors.email}
                touched={touched.email}
              >
                <EmailFieldControl
                  id="email"
                  name="email"
                  placeholder="juan.diaz@ejemplo.com"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  disabled={isSubmitting}
                  error={errors.email}
                  touched={touched.email}
                  required
                />
              </FormControl>
            </FormGroup>
            <FormGroup className="relative z-20">
              <FormControl
                htmlFor="country"
                label="País"
                error={errors.country}
                touched={touched.country}
              >
                <CountryFieldControl
                  htmlId="country"
                  name="country"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  validateForm={validateForm}
                  value={values.country}
                  disabled={isSubmitting}
                  error={errors.country}
                  hasError={countryHasError}
                  error={errors.country}
                  touched={touched.country}
                  required
                />              
              </FormControl>
            </FormGroup>
            <FormGroup>
              <FormControl
                htmlFor="message"
                label="Mensaje"
                error={errors.message}
                touched={touched.message}
              >
                <TextAreaControl
                  id="message"
                  name="message"
                  placeholder="Cuéntenos más sobre su proyecto, necesidades y cronograma."
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.message}
                  disabled={isSubmitting}
                  error={errors.message}
                  touched={touched.message}
                />
              </FormControl>
            </FormGroup>
            <FormActions>
              <FormSubmit
                label="Contactar con ventas"
                submitting={isSubmitting}
                disabled={isValid === false}
              />
            </FormActions>
            <input
              className="h"
              autocomplete="off"
              type="text"
              id="website"
              name="website"
              placeholder="Sitio web"
              onChange={handleChange}
              value={values.website}
            />
          </div>
        );
      }}
    </Form>
  );
}

SalesForm.defaultProps = defaultProps;
SalesForm.propTypes = propTypes;
